import React, { useState } from 'react';
import '../App.css';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  if (user) {
    navigate('/');
    return null;
  }

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    // Solo acepta admin/1234
    if (login(form.email, form.password)) {
      navigate('/');
    } else {
      setError('Usuario o contraseña incorrectos. Usa admin / 1234');
    }
  };

  return (
    <section className="login-page">
      <h2>Ingresar</h2>
      <form className="login-form-placeholder" onSubmit={handleSubmit}>
        <input type="email" name="email" placeholder="Usuario" value={form.email} onChange={handleChange} required />
        <input type="password" name="password" placeholder="Contraseña" value={form.password} onChange={handleChange} required />
        <button className="login-btn">Ingresar</button>
      </form>
      {error && <div className="login-error">{error}</div>}
      <div className="login-extra-links">
        <a href="/registro">¿No tienes cuenta? Regístrate</a>
        <a href="#">¿Olvidaste tu contraseña?</a>
      </div>
      <div className="login-demo-info">
        <em>Usuario demo: <b>admin@admin.com</b> | Contraseña: <b>1234</b></em>
      </div>
    </section>
  );
};

export default Login; 